/**
 * @generated SignedSource<<9b29a6555dae3f871475ad96615545ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClassicUIQueryLoaderQuery$variables = Record<PropertyKey, never>;
export type ClassicUIQueryLoaderQuery$data = {
  readonly user: {
    readonly " $fragmentSpreads": FragmentRefs<"currentUserKeyFragment">;
  } | null | undefined;
};
export type ClassicUIQueryLoaderQuery = {
  response: ClassicUIQueryLoaderQuery$data;
  variables: ClassicUIQueryLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "userLocator",
    "value": "current"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClassicUIQueryLoaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "currentUserKeyFragment"
          }
        ],
        "storageKey": "user(userLocator:\"current\")"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ClassicUIQueryLoaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Properties",
            "kind": "LinkedField",
            "name": "properties",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Property",
                "kind": "LinkedField",
                "name": "property",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAvatars",
            "kind": "LinkedField",
            "name": "avatars",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlToSize20",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlToSize28",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlToSize32",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlToSize40",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlToSize56",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlToSize64",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlToSize80",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "_id",
            "storageKey": null
          }
        ],
        "storageKey": "user(userLocator:\"current\")"
      }
    ]
  },
  "params": {
    "cacheID": "9559a2d233b93eb553b2c38548bf3bd2",
    "id": null,
    "metadata": {},
    "name": "ClassicUIQueryLoaderQuery",
    "operationKind": "query",
    "text": "query ClassicUIQueryLoaderQuery {\n  user(userLocator: \"current\") {\n    ...currentUserKeyFragment\n    _id\n  }\n}\n\nfragment AllUserSelectFragment on User {\n  id\n  avatars {\n    urlToSize40\n  }\n  name\n  username\n}\n\nfragment AvatarFragment on User {\n  id\n  name\n  username\n  avatars {\n    urlToSize20\n    urlToSize28\n    urlToSize32\n    urlToSize40\n    urlToSize56\n    urlToSize64\n    urlToSize80\n  }\n}\n\nfragment HeaderUserFragment on User {\n  id\n  name\n  username\n  ...AvatarFragment\n}\n\nfragment currentUserKeyFragment on User {\n  ...useMyIdFragment\n  ...useMyUsernameFragment\n  ...useUserPropertyFragment\n  ...useMyProfileFragment\n  ...HeaderUserFragment\n  ...AllUserSelectFragment\n}\n\nfragment useMyIdFragment on User {\n  id\n}\n\nfragment useMyProfileFragment on User {\n  name\n  username\n  email\n}\n\nfragment useMyUsernameFragment on User {\n  username\n}\n\nfragment useUserPropertyFragment on User {\n  properties {\n    property {\n      name\n      value\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dff036f867ed1eca4c6068bb4d828b05";

export default node;
